import { useContext } from 'react';

import { GoalMetricsFormContext } from './goal-metrics-form-context';

export const useOpenGoalMetricsForm = () => {
  const { onOpenMetricsForm } = useContext(GoalMetricsFormContext);

  return onOpenMetricsForm;
};
